import { useTranslation } from "react-i18next";
import { Grid } from "@mantine/core";
import dayjs from "dayjs";
import { CampaignQueryDataType } from "src/hooks/campaigns";

import { ReportSection } from "../components/ReportSection";
import { StatCard } from "../components/StatCard";

export interface ReportWhatTestedProps {
    campaign: CampaignQueryDataType;
}

export const ReportWhatTested = ({ campaign }: ReportWhatTestedProps) => {
    const { t } = useTranslation(["common"]);

    const openAt = campaign?.settings?.openAt;
    const closeAt = campaign?.settings?.closeAt;
    const period =
        openAt && closeAt ? `${dayjs(openAt).format("MM/YYYY")} – ${dayjs(closeAt).format("MM/YYYY")}` : undefined;

    const productCount = campaign?.products?.length || 0;
    const capacity = campaign?.settings?.capacity ?? 0;
    const applications = campaign?.totalApplicationsCount || 0;
    const selected = campaign?.selectedApplicationsCount || 0;

    return (
        <ReportSection
            title={t("campaign_report_what_tested")}
            meta={
                period && (
                    <>
                        {t("campaign_report_period")} <strong style={{ color: "#0F1B3D" }}>{period}</strong>
                    </>
                )
            }
        >
            <Grid>
                <Grid.Col sm={6} md={3}>
                    <StatCard value={productCount} label={t("campaign_report_products")} valueColor="#FB5B14" />
                </Grid.Col>
                <Grid.Col sm={6} md={3}>
                    <StatCard value={capacity.toLocaleString("cs-CZ")} label={t("campaign_report_capacity")} />
                </Grid.Col>
                <Grid.Col sm={6} md={3}>
                    <StatCard value={applications.toLocaleString("cs-CZ")} label={t("campaign_report_applications")} />
                </Grid.Col>
                <Grid.Col sm={6} md={3}>
                    <StatCard value={selected.toLocaleString("cs-CZ")} label={t("campaign_report_selected")} />
                </Grid.Col>
            </Grid>
        </ReportSection>
    );
};
